import { render, staticRenderFns } from "./PriceStandardlist.vue?vue&type=template&id=2f2d8762&scoped=true&"
import script from "./PriceStandardlist.vue?vue&type=script&lang=js&"
export * from "./PriceStandardlist.vue?vue&type=script&lang=js&"
import style0 from "./PriceStandardlist.vue?vue&type=style&index=0&id=2f2d8762&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2d8762",
  null
  
)

export default component.exports